import { HTMLProjectionNode } from "../../projection/node/HTMLProjectionNode";
import { MeasureLayout } from "./layout/MeasureLayout";
export const layout = {
    layout: {
        ProjectionNode: HTMLProjectionNode,
        MeasureLayout,
    },
};
//# sourceMappingURL=layout.js.map